import { Button } from '../atoms/Button/Button';
import { useTranslation } from '../../i18n/useTranslation';
import { useFeedbackOptional } from './FeedbackContext';

function FeedbackIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M3.5 3.5h13a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5H8l-3.5 3v-3h-1A1.5 1.5 0 0 1 2 13V5a1.5 1.5 0 0 1 1.5-1.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M6 7.5h8M6 10.5h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export interface FeedbackMenuButtonProps {
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  /** Collapsed sidebar: icon only (the accessible name stays). */
  iconOnly?: boolean;
}

/** "Feedback geben" entry in the sidebar footer — always available. */
export function FeedbackMenuButton({ className, iconClassName, labelClassName, iconOnly = false }: FeedbackMenuButtonProps) {
  const { t } = useTranslation();
  const feedback = useFeedbackOptional();
  if (feedback === null) return null;
  return (
    <Button
      variant="ghost"
      fullWidth
      className={className}
      onClick={feedback.open}
      aria-label={iconOnly ? t('appFeedback.menuEntry') : undefined}
      data-testid="feedback-menu-button"
    >
      <span className={iconClassName}><FeedbackIcon /></span>
      {!iconOnly && <span className={labelClassName}>{t('appFeedback.menuEntry')}</span>}
    </Button>
  );
}

export default FeedbackMenuButton;
